import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {PatientService} from '../service/patient.service';
import {ClientServiceService} from '../../client/client-service/client-service.service';

@Component({
  selector: 'app-patient-form',
  templateUrl: './patient-form.component.html',
  styleUrls: ['./patient-form.component.css']
})
export class PatientFormComponent implements OnInit {
  patientDetailForm: FormGroup;
  loading: boolean;
  submitted: boolean;
  client: any;

  createForm() {
    this.patientDetailForm = this._formBuilder.group({
      name: ['', Validators.required ]
    });
  }

  constructor(private _formBuilder: FormBuilder,
              private router: Router,
              private patientService: PatientService, private clientService: ClientServiceService,
              private toastr: ToastrService) {

    this.createForm();

    this.client=this.getClientDetails(localStorage.getItem('clientId'));

    this.patientDetailForm = this._formBuilder.group({
      id: [''],
      patientNumber: [''],
      addressLine1: [''],
      addressLine2: [''],
      city: [''],
      state: [''],
      postalCode: [''],
      country: [''],
      firstName: [''],
      lastName: [''],
      phoneNumberCell: [''],
      phoneNumberOffice: [''],
      emailId: [''],
      mrn: ['', Validators.required],
      clientId: localStorage.getItem('clientId'),
      comments: [''],
      patientAliasName: ['']
    }); }

  ngOnInit() {
  }

  public getClientDetails(clientId: any) {
        this.clientService.getClientById(clientId)
            .pipe(first())
            .subscribe(data => {
              console.log('client ::' + data.json())
              this.client = data.json();
            }, (error) => {
              this.toastr.error('', 'Please try again');
            });
    }

  public generateMRN(){
    console.log("Call code to generate MRN from server side!");
  }

  public savePatient(patientDetailForm: any) {
    this.loading = true;
    this.submitted = true;
    console.log(JSON.stringify(this.patientDetailForm.value));
    this.patientService.addUpdatePatient(patientDetailForm.value)
        .pipe(first())
        .subscribe(data => {
          if (data.status === 200) {
            this.toastr.success('', 'Patient saved successfully');
            this.router.navigate(['/elasticcare/patient']);
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          const errorResponse: any = JSON.parse(error._body);
          this.toastr.error('', errorResponse.message);
          this.loading = false;
        });
  }

}
